import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import users, { usersSaga } from './users';
import approvals, { approvalsSaga } from './approvals';
import schedules, { schedulesSaga } from './schedules';
import approval, { approvalSaga } from './approval';
import notices, { noticesSaga } from './notices';
import noticeFiles, { noticeFilesSaga } from './noticeFiles';

const userModule = combineReducers({
  users,
  approvals,
  schedules,
  approval,
  notices,
  noticeFiles
});

export function* userModuleSaga() {
  yield all([usersSaga(), approvalsSaga(),schedulesSaga(), approvalSaga(), noticesSaga(), noticeFilesSaga()]);
}

export default userModule;
